import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function Problem() {
  const problems = ['Respondés las mismas preguntas de precio una y otra vez por WhatsApp', 'El domingo lo pasás pensando qué publicar en Instagram la semana que viene', 'Cada presupuesto lo empezás de cero aunque sea casi igual al anterior', 'Los clientes que consultaron y no compraron se pierden porque no tenés seguimiento', 'No sabés exactamente cuánto ganás por cada producto porque los costos son un caos', 'Tus competidores ya usan IA y vos todavía no sabés por dónde empezar', 'Buscaste tutoriales de ChatGPT en YouTube pero ninguno habla de negocios argentinos reales', 'Lunes: mismo ciclo, mismas horas perdidas, mismo agotamiento que el lunes anterior'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-190">
      <div className="text-center mb-16" data-id="element-191">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-red mb-6" data-id="element-192">
          🔴 ¿Cuántas horas más vas a regalarle a tareas que la IA puede hacer
          por vos?
        </h2>
        <p className="text-lg text-gray-300 text-balance" data-id="element-193">
          Sos emprendedor/a argentino/a. Trabajás duro. Pero nadie te dijo que
          ibas a terminar respondiendo las mismas consultas por WhatsApp 15
          veces por día, creando contenido para Instagram a las 11 de la noche y
          haciendo presupuestos que siempre empiezan desde cero.
        </p>
        <p className="text-xl font-bold text-white mt-6" data-id="element-194">
          No es falta de capacidad. Es falta de un sistema.
        </p>
      </div>

      <div className="bg-red-950/20 border border-red-900/50 rounded-2xl p-6 md:p-8 mb-12" data-id="element-195">
        <h3 className="text-xl font-bold text-white mb-6 flex items-center gap-2" data-id="element-196">
          <XCircle className="text-brand-red w-6 h-6" data-id="element-197" />
          Lo que pasa sin el sistema
        </h3>
        <ul className="space-y-4" data-id="element-198">
          {problems.map((problem, index) => <motion.li key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-start gap-3 text-gray-300" data-id="element-199">
              <span className="text-brand-red font-bold mt-0.5" data-id="element-200">❌</span>
              <span data-id="element-201">{problem}</span>
            </motion.li>)}
        </ul>
      </div>

      <div className="bg-brand-violet/10 border border-brand-violet/30 rounded-2xl p-8 text-center relative overflow-hidden" data-id="element-202">
        <div className="absolute top-0 left-0 w-full h-1 bg-brand-violet" data-id="element-203" />
        <p className="text-sm text-brand-violet font-bold uppercase tracking-wider mb-4" data-id="element-204">
          La frase que más escuchamos
        </p>
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-6 italic" data-id="element-205">
          "Sé que debería usar IA pero no tengo tiempo para aprenderla"
        </h3>
        <p className="text-gray-300 mb-6" data-id="element-206">
          La paradoja: No tenés tiempo porque no usás IA. Y no usás IA porque
          creés que te lleva tiempo aprenderla.
        </p>
        <p className="text-xl font-bold text-brand-gold" data-id="element-207">
          Este kit rompe ese ciclo.
        </p>
      </div>

      <div className="text-center mt-12" data-id="element-208">
        <h3 className="text-2xl font-bold text-white" data-id="element-209">
          ✅ ¿Y si este fuera el último lunes que empezás así?
        </h3>
      </div>
    </section>;
}